<template>

  <!-- <p>Goal templates are pre-made goals that contain some recommended tasks and routines that you can try to implement in your life and adapt to your needs.</p> -->

<vs-collapse accordion type="margin" class="goal-templates-categories" >

     <vs-collapse-item class="mx-1" v-for="template in templates" :key="template.id">
        <div slot="header" class="pr-6">
          <div class="flex items-center">

            <div class="w-1/5 p-4"><img :src="template.img"/></div>
            <div class="w-4/5">
              <div class="font-bold text-dark text-xl">
                {{template.title}}
              </div>
              <div class="text-base text-dark">
                {{template.goal.title}}
              </div>

   <!--            <div class="text-sm">
                1 goal, 10 tasks
              </div> -->
            </div>
        </div>
      </div>
      <div class="cursor-default" >
<!--          <div class="text-sm font-italic mr-4 mb-4">
          {{template.goal.notes}}
        </div> -->

        <div v-if="template.tasks.length > 0">
          <div class="font-bold text-dark text-xl flex items-center mb-2">
            <feather-icon icon="CheckIcon" />
            <span class="ml-2">tasks</span>
          </div>

          <ul class="list-disc ml-8">
            <li v-for="task in template.tasks" :key="task.title" class=" font-medium mb-2">
              <AnchoredTitle class="text-black" :title="task.title"/>
              <!-- <div class="text-xs">{{task.notes}}</div> -->
            </li>
          </ul>
        </div>
        <div v-if="template.routines.length > 0" class="mt-4" >
          <div class="font-bold text-dark text-xl flex items-center mb-2">
            <feather-icon icon="RotateCwIcon" />
            <span class="ml-2">routines</span>
          </div>

          <ul class="list-disc ml-8">
            <li v-for="routine in template.routines" :key="routine.title" class=" font-medium mb-2">
              <AnchoredTitle class="text-black" :title="routine.title"/>
              <!-- <div class="text-xs">{{routine.notes}}</div> -->
            </li>
          </ul>

        </div>

        <div class="flex justify-center my-4">
          <vs-button icon-pack="feather" icon="icon-zap" @click="importTemplate(template)">
            import to action board
          </vs-button>
        </div>

      </div>

      </vs-collapse-item>


  </vs-collapse>

</template>

<script>

import GoalTemplates from '@/models/GoalTemplates'
import trackAnalytics from '@/helpers/trackAnalytics'
import _ from 'lodash'
export default {
  components: {
  },

  data () {
    return {
      templates: [],
    }
  },
  mounted () {
    this.templates = GoalTemplates.templates
    console.log(this.templates)
  },
  methods: {
    importTemplate (template) {

      this.$store.dispatch('ADD_GOAL', { goal: template.goal })
      _.each(template.tasks, (task) => { this.$store.dispatch('ADD_TASK', { task }) })
      _.each(template.routines, (routine) => { this.$store.dispatch('ADD_ROUTINE', { routine }) })
      trackAnalytics(this, 'app_action', 'get inspired - goal')
      this.$emit('imported')
    }
  }
}

</script>
<style scoped>
  ul {
    list-style-type: disc;
  }
</style>


<style>
.goal-templates-categories .vs-collapse-item--header {
  font-size: 1rem;
  padding: 0rem;
}

.goal-templates-categories .con-content--item {
  padding: 0 1rem 1rem  1rem !important;
}
.vs-collapse.margin .vs-collapse-item {
  border-radius: 1rem
}


</style>
